module.exports = __webpack_public_path__ + "0f220c6c809b3023311857ce045e5705.svg";